import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_LG, MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const cardsContainerStyles = css`
  display: grid;
  gap: var(${SpacingToken.Spacing6}) 0;
  grid-template-columns: 1fr;
  white-space: pre-wrap;

  ${MEDIA_MIN_SM} {
    gap: var(${SpacingToken.Spacing10}) var(${SpacingToken.Spacing4});
    grid-template-columns: 1fr 1fr;
  }

  ${MEDIA_MIN_LG} {
    gap: var(${SpacingToken.Spacing14}) var(${SpacingToken.Spacing5});
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const logBackLinkStyles = css`
  text-decoration: none;
  color: var(${DesignToken.ActionPrimaryDefault});
  font-weight: 600;
  font-size: 15px;
`;

export const logBackStyles = css`
  font-size: 16px;
  line-height: 32px;
  color: var(${DesignToken.ContentBasicPrimary});
`;

export const logoutTitleContainerStyles = css`
  margin-bottom: var(${SpacingToken.Spacing20});
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 720px) {
    margin-top: 104px;
  }
`;

export const logoutTitleStyles = css`
  color: var(${DesignToken.ContentBasicPrimary});
  margin: var(${SpacingToken.Spacing3}) 0;

  @media (min-width: 720px) {
    margin-top: var(${SpacingToken.Spacing6});
    margin-bottom: var(${SpacingToken.Spacing4});
  }

  @media (max-width: 720px) {
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
  }
`;

export const logoutMessageStyles = css`
  color: var(${DesignToken.ContentBasicPrimary});
  width: 227px;
  margin: var(${SpacingToken.Spacing10}) 0 var(${SpacingToken.Spacing8});

  @media (min-width: 720px) {
    font-size: 20px;
    width: auto;
  }

  @media (max-width: 720px) {
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }
`;
